import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useAuth } from '../../context/AuthContext';
import { flag } from '../../config';
import MobileNavHeader from './MobileNavHeader';
import MobileNavLoggedOut from './MobileNavLoggedOut';
import MobileNavLoggedIn from './MobileNavLoggedIn';
import MobileNavAudienceLinks from './MobileNavAudienceLinks';

/**
 * Main Mobile Navigation Container
 * 
 * Renders a slide-in drawer from the right side.
 * Content changes based on authentication state.
 */
export default function MobileNav({ isOpen, onClose }) {
  const { user, isAuthenticated } = useAuth();
  
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} className="relative z-50">
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
        </Transition.Child>
        
        {/* Drawer */}
        <div className="fixed inset-0 flex justify-end">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="w-full max-w-[340px] h-full">
              <div className="h-full bg-gradient-to-b from-[#1e1b4b] via-[#252259] to-[#2d2a5e] p-6 overflow-y-auto">
                
                {/* Header (always shown) */}
                <MobileNavHeader onClose={onClose} />
                
                {/* SLOT_MODEL: the audience links for signed-in users (signed-out has its own paths) */}
                {isAuthenticated && flag('SLOT_MODEL') && <MobileNavAudienceLinks onClose={onClose} />}
                
                {/* Content based on auth state */}
                {isAuthenticated ? (
                  <MobileNavLoggedIn user={user} onClose={onClose} />
                ) : (
                  <MobileNavLoggedOut onClose={onClose} />
                )}
                
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
